var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "license-information mt-1" },
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("div", { staticClass: "row body pt-4" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "container-fluid pdr-0 mgr-0" }, [
                  _c("div", { staticClass: "row ml-2 pdr-0 mgr-0" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", { staticClass: "data-label" }, [
                        _vm._v(" ¿La Licencia es Provisional? ")
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-radio", {
                                    key: _vm.provisionalFlag,
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor de seleccionar si la licencia es provisional o no",
                                      error: errors[0],
                                      "is-inline": "",
                                      name: "rbRecurrenceType",
                                      options: _vm.provisionalOptions
                                    },
                                    on: { input: _vm.provisionalFlagChanged },
                                    model: {
                                      value: _vm.provisionalFlag,
                                      callback: function($$v) {
                                        _vm.provisionalFlag = $$v
                                      },
                                      expression: "provisionalFlag"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row ml-2 pdr-0 mgr-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-6 col-lg-5 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: "LicenseType",
                            rules: { required: true, notEmptyObject: "id" }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor de seleccionar una Especialidad",
                                      disabled:
                                        _vm.license.specialistLicenseId != null,
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Especialidad:",
                                      options: _vm.filteredSpecialtyTypes,
                                      placeholder: "Seleccione",
                                      reduce: o => ({ id: o.id, name: o.name })
                                    },
                                    on: { input: _vm.onChangeSpecialtyHandler },
                                    model: {
                                      value: _vm.selectedSpecialty,
                                      callback: function($$v) {
                                        _vm.selectedSpecialty = $$v
                                      },
                                      expression: "selectedSpecialty"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm.hasDetail
                      ? _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-6 col-lg-4 mb-3" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "LicenseNo", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              _vm.validationMessages.licenseNo,
                                            disabled: _vm.cantEditLicenseNo,
                                            error: errors[0],
                                            label: "Número de Licencia:"
                                          },
                                          model: {
                                            value:
                                              _vm.specialistLicense.licenseNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.specialistLicense,
                                                "licenseNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "specialistLicense.licenseNo"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2141452364
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasDetail
                      ? _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-4 col-lg-3 mb-3" },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "LicenseExpireDate",
                                rules: "required"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          attrs: {
                                            "custom-error-msg":
                                              _vm.validationMessages
                                                .licenseExpireDate,
                                            error: errors[0],
                                            label: "Fecha de Expiración:",
                                            "min-date": new Date()
                                          },
                                          model: {
                                            value:
                                              _vm.specialistLicense
                                                .licenseExpireDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.specialistLicense,
                                                "licenseExpireDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "specialistLicense.licenseExpireDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                544769599
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasDetail
                      ? _c(
                          "div",
                          { staticClass: "col-sm-12 col-md-6 col-lg-3 mb-3" },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "AgeRange",
                                rules: { required: true, notEmptyObject: "id" }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              _vm.validationMessages.ageRange,
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Rango de Edad:",
                                            options: _vm.ageRanges,
                                            placeholder: "Seleccione",
                                            reduce: o => ({
                                              id: o.id,
                                              name: o.name
                                            })
                                          },
                                          model: {
                                            value: _vm.selectedAgeRange,
                                            callback: function($$v) {
                                              _vm.selectedAgeRange = $$v
                                            },
                                            expression: "selectedAgeRange"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3522204449
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasDetail && _vm.showSupervisorCheck
                      ? _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-4 col-lg-2 mb-3" },
                          [
                            _c("check-box", {
                              staticClass: "checkbox",
                              attrs: { text: "Supervisor" },
                              model: {
                                value: _vm.specialistLicense.supervisorFlag,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.specialistLicense,
                                    "supervisorFlag",
                                    $$v
                                  )
                                },
                                expression: "specialistLicense.supervisorFlag"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "pl-4" },
            [
              _c("license-documents", {
                on: {
                  "delete-document": _vm.deleteDocument,
                  "download-document": _vm.downloadDocument
                },
                model: {
                  value: _vm.specialistLicense,
                  callback: function($$v) {
                    _vm.specialistLicense = $$v
                  },
                  expression: "specialistLicense"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("action-button", {
                  staticClass: "py-2 mt-4 float-right",
                  attrs: {
                    i: "fas fa-plus",
                    text: "Guardar",
                    variant: "success"
                  },
                  on: { click: _vm.save }
                }),
                _c("action-button", {
                  staticClass: "mr-3 mt-4 py-2 btnCancel float-right",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger"
                  },
                  on: { click: _vm.cancel }
                })
              ],
              1
            )
          ]),
          _vm.customErrorMessage != null
            ? _c("error", {
                attrs: { message: _vm.customErrorMessage, variant: "no-border" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }